export const GRADE_OPTIONS = [
  { value: "Kindergarten", label: "Kindergarten" },
  { value: "1st Grade", label: "1st Grade" },
  { value: "2nd Grade", label: "2nd Grade" },
  { value: "3rd Grade", label: "3rd Grade" },
  { value: "4th Grade", label: "4th Grade" },
  { value: "5th Grade", label: "5th Grade" },
  { value: "6th Grade", label: "6th Grade" },
  { value: "7th Grade", label: "7th Grade" },
  { value: "8th Grade", label: "8th Grade" },
  { value: "9th Grade", label: "9th Grade" },
  { value: "10th Grade", label: "10th Grade" },
  { value: "11th Grade", label: "11th Grade" },
  { value: "12th Grade", label: "12th Grade" },
];

const GRADE_VALUES_SET = new Set(GRADE_OPTIONS.map((g) => g.value));

const GRADE_NUMBER_TO_VALUE = {
  0: "Kindergarten",
  1: "1st Grade",
  2: "2nd Grade",
  3: "3rd Grade",
  4: "4th Grade",
  5: "5th Grade",
  6: "6th Grade",
  7: "7th Grade",
  8: "8th Grade",
  9: "9th Grade",
  10: "10th Grade",
  11: "11th Grade",
  12: "12th Grade",
};

/** Back-compat for old saved values that may have been stored as numbers ("1".."12" or "0"). */
export function mapGradeValue(gradeInput) {
  const raw = gradeInput == null ? "" : String(gradeInput).trim();
  if (!raw) return "";
  if (GRADE_VALUES_SET.has(raw)) return raw;
  if (/^k$/i.test(raw)) return "Kindergarten";
  const n = parseInt(raw, 10);
  if (!Number.isNaN(n) && Object.prototype.hasOwnProperty.call(GRADE_NUMBER_TO_VALUE, n)) {
    return GRADE_NUMBER_TO_VALUE[n];
  }
  return "";
}

export function getGradeLabel(value) {
  const v = mapGradeValue(value || "");
  if (!v) return "—";
  const opt = GRADE_OPTIONS.find((x) => x.value === v);
  return opt ? opt.label : v;
}

